import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  ALL,
} from '@app/Seller/accessTokens'

const ModulesBase = () => import('@app/Seller/Components/Base')
const ModulesLiqpay = () => import('@app/Seller/Modules/Liqpay/View')

const MODEL = 'modules'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const LIQPAY_VIEW = 'liqpay/'

export const MODULES_PREFIX = `${MODEL}:`
const p = name => MODULES_PREFIX + name

export const MODULES_BASE_NAME = p('base')

export const MODULES_LIQPAY_NAME = p('liqpay')

export function createRoutes(options) {
  return [
    route(BASE, ModulesBase, MODULES_BASE_NAME, {
      meta: accessPermission(ALL, options),
      children: [
        route(LIQPAY_VIEW, ModulesLiqpay, MODULES_LIQPAY_NAME, {
          meta: {
            ...accessPermission(ALL, options),
          },
        }),
      ],
    }),
  ]
}
